// extracted by mini-css-extract-plugin
export default {"row":"Ax9QUG0ePql1D-qJQ9T3mQ==","label":"Q8Zz9+kjgsnaIJQ1BfnTiQ=="};